import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { Seo } from "@/components/Seo";

export default function Cookies() {
  return (
    <LegalLayout title="Cookie Policy" updated="July 2026">
      <Seo
        title="Cookie Policy | Aliwer"
        description="How Aliwer uses essential and optional cookies, the categories we use, and how you can manage your cookie choices."
        path="/cookies"
      />
      <p className="text-sm text-fog leading-relaxed">
        This Cookie Policy explains how Aliwer uses cookies and similar technologies on our
        website, and how you can manage your choices.
      </p>

      <LegalSection n="01" title="What cookies are">
        <p>
          Cookies are small text files stored on your device that help websites function and
          remember information about your visit.
        </p>
      </LegalSection>

      <LegalSection n="02" title="Essential cookies">
        <p>
          These are required for the site to work — for example, to keep you signed in and to
          secure your session. They cannot be switched off in our systems.
        </p>
      </LegalSection>

      <LegalSection n="03" title="Optional analytics cookies">
        <p>
          With your consent, we use analytics cookies to understand how the site is used so we
          can improve it. You can accept or decline these via the consent banner shown on your
          first visit.
        </p>
      </LegalSection>

      <LegalSection n="04" title="Managing your choices">
        <p>
          You can change your decision at any time by clearing this site's data in your browser
          (which will re-show the banner) or by adjusting your browser's cookie settings.
        </p>
      </LegalSection>

      <LegalSection n="05" title="More information">
        <p>
          For details on how we handle personal data, see our{" "}
          <a href="/privacy" className="underline hover:text-paper">Privacy Policy</a>. Questions? Email
          aliwer.usa@gmail.com.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
